'use client';

// https://ui.shadcn.com/docs/components/checkbox
import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import clsx from 'clsx';

import { Check, Indeterminate } from '../Icons';

import styles from './Checkbox.module.scss';

type CheckboxProps = ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
  variant?: 'danger'; // extend as a union e.g. 'danger' | 'warning'
};

const Checkbox = forwardRef<ElementRef<typeof CheckboxPrimitive.Root>, CheckboxProps>(
  ({ className, variant, ...props }, ref) => (
    <CheckboxPrimitive.Root
      ref={ref}
      className={clsx(styles.root, { [styles.danger]: variant === 'danger' }, className)}
      {...props}
    >
      <CheckboxPrimitive.Indicator className={clsx(styles.indicator)}>
        {props.checked === 'indeterminate' ? (
          <Indeterminate className={clsx(styles.check)} />
        ) : (
          <Check className={clsx(styles.check)} />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  ),
);
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
